/* ============================================================
   TOBACCONIST — Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Cart Drawer ──
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const openCartBtns = document.querySelectorAll('[data-open-cart]');
  const closeCartBtns = document.querySelectorAll('[data-close-cart]');

  function openCart() {
    cartDrawer?.classList.add('is-open');
    cartOverlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    cartOverlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  openCartBtns.forEach(btn => btn.addEventListener('click', openCart));
  closeCartBtns.forEach(btn => btn.addEventListener('click', closeCart));
  cartOverlay?.addEventListener('click', closeCart);

  // Note: the cart page's own quantity selector (+/-) is handled entirely
  // by the inline script in sections/main-cart.liquid, which also syncs
  // the change to the server via /cart/change.js. A generic handler used
  // to live here too and was double-firing on the same buttons (each
  // click bumped the value by 2 instead of 1) — removed to fix that.

  // ── Scroll Fade-Up Animation ──
  const fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeEls.forEach(el => observer.observe(el));
  }

  // ── Product Gallery Thumbnails ──
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
      }
    });
  });

  // ── Mobile Nav Toggle ──
  const navToggle = document.querySelector('[data-nav-toggle]');
  const mobileNav = document.querySelector('.mobile-nav');

  navToggle?.addEventListener('click', function () {
    const isOpen = mobileNav?.classList.toggle('is-open');
    navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  // ── Hero Panel Image Carousel ──
  document.querySelectorAll('[data-hero-carousel]').forEach(function (carousel) {
    const slides = carousel.querySelectorAll('[data-hero-slide]');
    const dots = carousel.querySelectorAll('[data-hero-dot]');
    const prevBtn = carousel.querySelector('[data-hero-prev]');
    const nextBtn = carousel.querySelector('[data-hero-next]');
    if (slides.length < 2) return;

    let current = 0;
    let timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(next, 3000);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    prevBtn?.addEventListener('click', function () { prev(); startAutoplay(); });
    nextBtn?.addEventListener('click', function () { next(); startAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
        startAutoplay();
      });
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });

});
